/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import { commonVariable } from 'api/config'
import { setCookie, getCookie, removeCookie, setCookieSession, getCookieSession, removeCookieSession } from 'assets/js/cookie'
import cookies from 'vue-cookie'

let elementStyle = document.createElement('div').style
let vendor = (() => {
  let transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  }
  for (let key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key
    }
  }
  return false
})()
export const routerPrefix = ''

export let browser = {
  versions: (function () {
    var u = navigator.userAgent,
      app = navigator.appVersion
    return {
      // 移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') == -1 // 是否web应该程序，没有头部与底部
    }
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  type: getbrowserType
}

export function getbrowserType () {
  if (browser.versions.mobile) {
    var ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      if (browser.versions.android) {
        return 1.1
      } else if (browser.versions.ios) {
        return 1.2
      }
      return 1
    }
    if (browser.versions.ios) {
      return 2
    }
    if (browser.versions.android) {
      //  是否在安卓浏览器打开
      return 3
    }
  } else {
    //  是否在桌面浏览器打开
    if (browser.versions.trident) {
      return 4
    }
    return 0
  }
}

export function uuid (len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = [],
    i
  radix = radix || chars.length
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    var r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

export function getUrlParameter (sParam, sPageURL, split) {
  var sURLVariables = sPageURL.split(split)
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=')
    if (sParameterName[0] == sParam) {
      return sParameterName[1]
    }
  }
  return ''
}

export let cookieOperate = {
  setAuthorToken: function (val) {
    cookies.set('EeidmAuthorToken', val, {
      domain: '.eeidm.com'
    })
  },
  getAuthorToken: function () {
    return cookies.get('EeidmAuthorToken')
  },
  removeAuthorToken: function () {
    return cookies.delete('EeidmAuthorToken', {
      domain: config.cookieDomain
    })
  },
  setUserInfo: function (val) {
    cookies.set('EeidmUserInfo', val, {
      domain: config.cookieDomain
    })
  // setCookie('EeidmUserInfo', val)
  },
  getUserInfo: function () {
    // return getCookie('EeidmUserInfo')
    var info = cookies.get('EeidmUserInfo', {
      domain: config.cookieDomain
    })
    return info ? JSON.parse(info) : null
  },
  removeUserInfo: function () {
    return cookies.delete('EeidmUserInfo', {
      domain: config.cookieDomain
    })
  },
  setOrderVTime: function (val) {
    setCookie('EeidmOrderVTime', val)
  },
  getOrderVTime: function () {
    return getCookie('EeidmOrderVTime')
  },
  removeOrderVTime: function () {
    return removeCookie('EeidmOrderVTime')
  },
  setOrderInfo: function (val) {
    setCookie('EeidmOrderInfo', val)
  },
  getOrderInfo: function () {
    //  var info = getCookie('EeidmOrderInfo') 
    //   var cinfo = cookies.get('EeidmOrderInfo', {
    //     domain: config.cookieDomain
    //   })
    //   console.log(JSON.parse(cinfo), "orderInfocccccc")
    //    console.log(info, "orderInfo0")
    //   if (cinfo) {
    //     return JSON.parse(cinfo)
    //   } else if (info) {
    //     return info
    //   } else { 
    //      return null
    //   }
    // return info ? JSON.parse(info) : null
    return getCookie('EeidmOrderInfo')
  },
  removeOrderInfo: function () {
    return removeCookie('EeidmOrderInfo')
  },
  setOrderInquireState: function (val) {
    setCookie('EeidmOrderInquireState', val)
  },
  getOrderInquireState: function () {
    //    var info = getCookie('EeidmOrderInquireState')
    //    var cinfo = cookies.get('EeidmOrderInquireState', {
    //      domain: config.cookieDomain
    //    })
    // console.log(info, "orderStateInfo")
    //  console.log(JSON.parse(cinfo), "orderStateInfocc")
    //    if (cinfo) {
    //      return JSON.parse(cinfo)
    //    } else if (info) {
    //      return info
    //    } else {
    //      return null
    // }

    // var info = getCookie('EeidmOrderInquireState') || cookies.get('EeidmOrderInquireState', {
    //   domain: config.cookieDomain
    // })
    // console.log(JSON.parse(info), "EeidmOrderInquireState")
    // return info ? JSON.parse(info) : null
    return getCookie('EeidmOrderInquireState')
  },
  removeOrderInquireState: function () {
    return removeCookie('EeidmOrderInquireState')
  },
  setWechatOpenID: function (val) {
    setCookie('WechatOpenID', val)
  },
  setBeforeLoginPage: function (val) {
    setCookieSession('beforeLoginPage', val)
  },
  getBeforeLoginPage: function () {
    return getCookieSession('beforeLoginPage')
  },
  removeBeforeLoginPage: function () {
    return removeCookieSession('beforeLoginPage')
  },
  setWeChatOpenGuid: function (val) {
    setCookie('WeChatOpen', val)
  },
  getWeChatOpenGuid: function () {
    return getCookie('WeChatOpen')
  },
  removeWeChatOpenGuid: function () {
    return removeCookie('WeChatOpen')
  },
  setBannerState: function (val) {
    cookies.set('bannerState', val, {
      domain: config.cookieDomain
    })
  },
  getBannerState: function () {
    var info = cookies.get('bannerState', {
      domain: config.cookieDomain
    })
    return info ? JSON.parse(info) : null
  }
}

export class Stack {
  constructor () {
    this.stacks = []
  }

  out () {
    return this.stacks.pop()
  }

  enter (item) {
    this.stacks.push(item)
    return this.stacks
  }

  szie () {
    return this.stacks.length
  }

  getStacks () {
    return this.stacks
  }
}

export let common = {
  hasClass(el, className) {
    let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
    return reg.test(el.className)
  },
  addClass(el, className) {
    if (hasClass(el, className)) {
      return
    }
    let newClass = el.className.split(' ')
    newClass.push(className)
    el.className = newClass.join(' ')
  },
  getData(el, name, val) {
    const prefix = 'data-'
    const attributeName = prefix + name
    if (val) {
      return el.setAttribute(attributeName, val)
    }
    return el.getAttribute(attributeName)
  },
  getWechatVersion() {
    var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\\.]+)/i)
  },
  getbrowserType() {
    if (browser.versions.mobile) {
      var ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        if (browser.versions.android) {
          return 1.1
        } else if (browser.versions.ios) {
          return 1.2
        }
        return 1
      }
      if (browser.versions.ios) {
        return 2
      }
      if (browser.versions.android) {
        //  是否在安卓浏览器打开
        return 3
      }
    } else {
      //  是否在桌面浏览器打开
      if (browser.versions.trident) {
        return 4
      }
      return 0
    }
  },
  uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = [],
      i
    radix = radix || chars.length
    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
      // rfc4122, version 4 form
      var r

      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'

      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
        }
      }
    }

    return uuid.join('')
  },
  getUrlParameter(sParam, sPageURL, split) {
    var sURLVariables = sPageURL.split(split)
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split('=')
      if (sParameterName[0] == sParam) {
        return sParameterName[1]
      }
    }
    return ''
  },
  request: {
    tipMsg($this, data) {
      $this.toptipTxt = data.message
      $this.$refs.toptip.show()
    }
  },
  calculateWH(num) {
    var windowW = parseInt(window.outerWidth || window.innerWidth || window.screen.width)
    windowW = windowW > 1550 ? 1550 / 10 : windowW / 10
    return num / config.originWidth * windowW
  },
  cssPrefix(style) {
    if (vendor === false) {
      return false
    }
    if (vendor === 'standard') {
      return style
    }
    return vendor + style.charAt(0).toUpperCase() + style.substr(1)
  },
  compile(code) {
    if (!code) {
      return code
    }
    var c = String.fromCharCode(code.charCodeAt(0) + code.length)
    for (var i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
    }
    return decodeURIComponent(c)
  },
  uncompile(code) {
    if (!code) {
      return code
    }
    code = encodeURIComponent(code)
    var c = String.fromCharCode(code.charCodeAt(0) - code.length)
    for (var i = 1; i < code.length; i++) {
      c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
    }
    return c
  },
  deuce(arr, deuceNum) {
    var deuceItem = [],
      deuceArr = []
    for (var i = 0, len = arr.length; i < len; i++) {
      var isBreakpoint = i % deuceNum === 0
      if (isBreakpoint) {
        deuceItem = []
        deuceItem.push(arr[i])
        deuceArr.push(deuceItem)
      } else {
        deuceItem.push(arr[i])
      }
    }
    return deuceArr
  },
  deepClone(obj) {
    var newObj = obj instanceof Array ? [] : {}
    for (let i in obj) {
      newObj[i] = typeof obj[i] == 'object' ? common.deepClone(obj[i]) : obj[i]
    }
    return newObj
  },
  openClient: function (scheme, yingYongBaoUrl) {
    // 打开应用或者跳转到应用宝产品网址
    var ua = navigator.userAgent.toLowerCase()
    var config = {
      scheme_IOS: scheme + '://',
      scheme_Adr: scheme + '://splash',
      download_url: yingYongBaoUrl,
      timeout: 2000
    }
    var startTime = Date.now()
    var ifr = document.createElement('iframe')
    var downUrl
    ifr.src = ua.indexOf('os') > 0 ? config.scheme_IOS : config.scheme_Adr
    downUrl = ua.indexOf('os') > 0 ? config.download_url : config.download_url
    ifr.style.display = 'none'
    document.body.appendChild(ifr)
    var t = setTimeout(function () {
      var endTime = Date.now()
      if (!startTime || endTime - startTime < config.timeout + 200) {
        window.location = downUrl
      } else {}
    }, config.timeout)
    window.onblur = function () {
      clearTimeout(t)
    }
  },
  // 登录地址
  toLogin(page) {
    const loginUrl = process.env.NODE_ENV === 'production' ? 'login/index' : 'login/index' // 判断跳转地址路径
    var url = `${config.domain}/${loginUrl}?rediUrl=${encodeURIComponent(page || window.location.href)}`
    window.location.href = url
  },
  createPSBContractNumber() {
    var rd = '1' + Math.random()
    var time = new Date()
    var cime = new Date(2013, 0, 1)
    var times = time.getTime() - cime.getTime()
    var s = (times + '1').substring(0, 11)
    return '8' + s + rd.substring(5, 6)
  },
  getClientHeight() {
    var clientHeight = 0
    if (document.body.clientHeight && document.documentElement.clientHeight) {
      clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight
    } else {
      clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ? document.body.clientHeight : document.documentElement.clientHeight
    }
    return clientHeight
  },
  getDocHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
  },
  isScrollToDom(target, distance) {
    var clientH = this.getClientHeight(),
      scrollY = document.documentElement.scrollTop || document.body.scrollTop,
      targetH = target.offsetHeight,
      targetTop = target.offsetTop,
      targetCH = target.getBoundingClientRect().top
    var CH = clientH + scrollY
    if (distance) {
      return {
        arrive: CH >= targetTop && CH <= (targetTop + targetH) && targetCH < distance,
        exceed: CH > (targetTop + targetH)
      }
    }
    return {
      arrive: CH >= targetTop && CH <= (targetTop + targetH),
      exceed: CH > (targetTop + targetH)
    }
  },
  matchBrackets(str) {
    let strArr = str.split(''),
      brackets = '({[]})',
      index = -1,
      stacks = new Stack()
    for (let i = 0, len = strArr.length; i < strArr.length; i++) {
      let item = strArr[i]
      index = brackets.indexOf(item)
      if (index < 3) {
        // 左括号
        stacks.enter(item)
      } else {
        // 右括号
        let target = stacks.out()
        if (!target) {
          return {
            index: i,
            item: item,
            mesg: '末尾或者首位有不匹配'
          }
        }
        if (item !== brackets[brackets.length - 1 - index]) {
          return {
            index: i,
            item: item
          }
        }
      }
    }
    if (stacks.szie() > 0) {
      return stacks.getStacks()
    }
    return '匹配成功'
  }
}

export function hasClass (el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

export function addClass (el, className) {
  if (hasClass(el, className)) {
    return
  }
  let newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

export function getData (el, name, val) {
  const prefix = 'data-'
  const attributeName = prefix + name
  if (val) {
    return el.setAttribute(attributeName, val)
  }
  return el.getAttribute(attributeName)
}

// 页面跳转地址配置
export let config = {
  indexPageUrl: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://devplatform.eeidm.com/' : 'https://www.eeidm.com/',
  // domain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://dev.eeidm.com' : 'https://www.eeidm.com', // 2021.5.27转内部服务器地址
  domain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://devplatform.eeidm.com' : 'https://www.eeidm.com',
  cookieDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? '.eeidm.com' : '.eeidm.com',
  // cookieDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'http://192.168.10.205' : '.eeidm.com',
  idfmDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://devplatform.idfm.cn' : 'https://www.idfm.cn',
  idhmDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://idh.devplatform.eeidm.com' : 'https://idh.eeidm.com',
  serverDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://server.dev.eeidm.com' : 'https://server.eeidm.com',
  compDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://comp.devplatform.eeidm.com' : 'https://comp.eeidm.com',
  orderDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://order.devplatform.eeidm.com' : 'https://order.eeidm.com',
  originWidth: 128,
  payRedirectUri: process.env.NODE_ENV === 'development' ? 'https://open.dev.tech2real.com/m-web/payresult' : 'https://open.dev.tech2real.com/m-web/payresult'
}
// 备份链接 -数据
// export let config = {
//   indexPageUrl: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://dev.eeidm.com/' : 'https://www.eeidm.com/',
//   domain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://dev.eeidm.com' : 'https://www.eeidm.com',
//   cookieDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? '.eeidm.com' : '.eeidm.com',
//   idfmDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://dev.idfm.cn' : 'https://www.idfm.cn',
//   idhmDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://idh.dev.eeidm.com' : 'https://idh.eeidm.com',
//   serverDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://server.dev.eeidm.com' : 'https://server.eeidm.com',
//   compDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://comp.dev.eeidm.com' : 'https://comp.eeidm.com',
//   orderDomain: process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV === 'development' ? 'https://order.dev.eeidm.com' : 'https://order.eeidm.com',
//   originWidth: 128,
//   payRedirectUri: process.env.NODE_ENV === 'development' ? 'https://open.dev.tech2real.com/m-web/payresult' : 'https://open.dev.tech2real.com/m-web/payresult'
// }

export function formErrorMsg ({errorObj, name, message, rule, scope, interval}) {
  errorObj.clear(scope)
  errorObj.add({
    field: name,
    msg: message,
    rule,
  scope})
  if (interval) {
    setTimeout(() => {
      errorObj.clear(scope)
    }, interval)
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/util.js